<script>
    import CRUD from './CRUD.svelte';
    import { 
        fetchRoles, 
        saveRole, 
        removeRole, 
        searchRoles, 
        subscribeToRoles, 
        unsubscribeFromRoles 
    } from '../controllers/roleController.js';
    import { onMount } from 'svelte';

    let roleColumns = [
        { label: 'Descripción', field: 'descrip', type: 'text' },
        { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    let newRole = {
        descrip: '',
        sta: true,
    };

    let editColumns = [
        { label: 'Descripción', key: 'descrip', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox' },
    ];

    onMount(() => {
        console.log("Componente de Roles montado");
    });
</script>

<CRUD 
    title="Roles"
    entityName="role"
    newEntity={newRole}
    columns={roleColumns}
    fetchEntities={fetchRoles}
    saveEntity={saveRole}
    removeEntity={removeRole}
    searchEntities={searchRoles}
    subscribeToChanges={subscribeToRoles}
    unsubscribeFromChanges={unsubscribeFromRoles}
    editColumns={editColumns}
/>